import Vue from 'vue';
import { HTTP_GET, HTTP_POST, HTTP_PUT } from "../const";
import {
  LOAD_SCRIPTS_LIST,
  LOAD_TOR_NODES_LIST,
  RESET_SERVER,
  RESTART_SCRIPT, RESTART_TOR_NODE, RESTART_TOR_SERVICE,
  STOP_SCRIPT
} from "@/store/const/server";

export default {
  namespaced: true,
  state: {
    torNodes: [],
    scripts: [],
  },
  getters: {
    torNodes: state => state.torNodes,
    scripts: state => state.scripts,
  },
  actions: {
    [LOAD_TOR_NODES_LIST]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_TOR_NODES_LIST,
        namespace: 'server',
      }, {root: true});
    },
    [LOAD_SCRIPTS_LIST]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_SCRIPTS_LIST,
        namespace: 'server',
      }, {root: true});
    },
    [RESTART_SCRIPT]: async ({ dispatch }, id) => {
      const request = await dispatch(HTTP_PUT, {
        method: RESTART_SCRIPT,
        replace: { id },
        no_commit: true,
        namespace: 'server',
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [STOP_SCRIPT]: async ({ dispatch }, id) => {
      const request = await dispatch(HTTP_PUT, {
        method: STOP_SCRIPT,
        replace: { id },
        no_commit: true,
        namespace: 'server',
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [RESTART_TOR_NODE]: async ({ dispatch }, id) => {
      const request = await dispatch(HTTP_PUT, {
        method: RESTART_TOR_NODE,
        replace: { id },
        no_commit: true,
        namespace: 'server',
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [RESTART_TOR_SERVICE]: async ({ dispatch }) => {
      const request = await dispatch(HTTP_PUT, {
        method: RESTART_TOR_SERVICE,
        no_commit: true,
        namespace: 'server',
        timeout: 60000,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
  },
  mutations: {
    [LOAD_TOR_NODES_LIST]: (state, { data }) => {
      Vue.set(state, 'torNodes', data);
    },
    [LOAD_SCRIPTS_LIST]: (state, { data }) => {
      Vue.set(state, 'scripts', data);
    },
    [RESET_SERVER]: (state) => {
      Vue.set(state, 'torNodes', []);
      Vue.set(state, 'scripts', []);
    },
  },
};
